module.exports = __webpack_public_path__ + "img/20180815_151538_146.d6908059.jpg";